import { Component, Input } from '@angular/core';
import { Tarif } from '../../models/tarif';

@Component({
  selector: 'app-grille-achat-services',
  templateUrl: './grille-achat-services.component.html',
  styleUrls: ['./grille-achat-services.component.scss'],
})
export class GrilleAchatServicesComponent {
  @Input() tarifs: Tarif[] = [];
}
